export default "__VITE_ASSET__BtSPYcQE__"